
export default function FeaturesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Welcome
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            Not Your Typical Photo Booth. Most booths capture moments.
            <br />
            <strong className="text-gray-900">Ours create experiences.</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-camera-3-line text-3xl text-orange-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Exclusive Overhead 360 Video Booth
            </h3>
            <p className="text-gray-600">
              Experience the latest in event entertainment with our premium overhead 360 video booth technology.
            </p>
          </div>

          <div className="text-center p-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-movie-2-line text-3xl text-orange-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Cinematic Slow-Motion Effects
            </h3>
            <p className="text-gray-600">
              Create stunning slow-motion videos that capture every moment in breathtaking detail.
            </p>
          </div>

          <div className="text-center p-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-star-line text-3xl text-orange-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Professional Attendants
            </h3>
            <p className="text-gray-600">
              Our experienced team ensures smooth operation and helps your guests create amazing content.
            </p>
          </div>

          <div className="text-center p-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-lightbulb-flash-line text-3xl text-orange-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Premium Lighting & Equipment
            </h3>
            <p className="text-gray-600">
              Professional-grade lighting and equipment ensure picture-perfect results every time.
            </p>
          </div>

          <div className="text-center p-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-3xl text-orange-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Trusted by San Diego
            </h3>
            <p className="text-gray-600">
              Preferred by weddings, brands, and event planners across San Diego County.
            </p>
          </div>

          <div className="text-center p-6">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-3-line text-3xl text-orange-500"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">
              Unforgettable Memories
            </h3>
            <p className="text-gray-600">
              We don't just capture moments – we create experiences your guests will never forget.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
